// App.js - Updated for Build3 Integration
import React, { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import Login from './Login';
import CandidateForm from './CandidateForm';
import { checkCandidateStatus } from './utils';
import './App.css';

function App() {
  
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [candidateStatus, setCandidateStatus] = useState(null);
  const [checkingStatus, setCheckingStatus] = useState(false);
  const [submittedSuccess, setSubmittedSuccess] = useState(false);

  // Track if we're in edit mode
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setUser(user);
      
      if (user) {
        // Perform Build3 candidate check after login
        // console.log('👤 User logged in:', user.email);
        setCheckingStatus(true);
        
        const status = await checkCandidateStatus(user.email);
        // console.log('📊 Build3 candidate status result:', status);
        
        setCandidateStatus(status);
        setCheckingStatus(false);
      } else {
        setCandidateStatus(null);
        setIsEditMode(false);
        setSubmittedSuccess(false);
      }
      
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleLoginSuccess = async (user) => {
    // console.log('🎉 Login successful for:', user.email);
    setUser(user);
    setCheckingStatus(true);
    
    // Check candidate status
    const status = await checkCandidateStatus(user.email);
    // console.log('📊 Candidate status after login:', status);
    
    setCandidateStatus(status);
    setCheckingStatus(false);
  };

  const handleSubmissionSuccess = (formData, wasExisting) => {
    // console.log('🎉 Form submission successful');
    setCandidateStatus(prevStatus => ({
      ...prevStatus,
      existingData: {
        ...formData,
        isInterviewDone: prevStatus?.existingData?.isInterviewDone ?? false,
        isMetricDone: prevStatus?.existingData?.isMetricDone ?? false
      }
    }));
    setSubmittedSuccess(true);
    setIsEditMode(false);
  };

  // Show loading spinner during initial load or candidate status check
  if (loading || checkingStatus) {
    return (
      <div className="app-loading">
        <div className="loading-spinner"></div>
        <p>{checkingStatus ? 'Checking your NeoCareers status...' : 'Loading...'}</p>
      </div>
    );
  }

  // Not logged in - show login
  if (!user) {
    return (
      <div className="App">
        <Login onLoginSuccess={handleLoginSuccess} />
      </div>
    );
  }

  return (
    <div className="App">
      <CandidateForm
        user={user}
        existingData={candidateStatus?.existingData || null}
        welcomeMessage={candidateStatus?.message || ''}
        isExistingCandidate={!candidateStatus?.isNewCandidate}
        isEditMode={isEditMode}
        submittedSuccess={submittedSuccess}
        isInterviewDone={candidateStatus?.existingData?.isInterviewDone ?? false}
        isMetricDone={candidateStatus?.existingData?.isMetricDone ?? false}
        onSubmissionSuccess={handleSubmissionSuccess}
      />
    </div>
  );
}

export default App;